import { chatMessages } from "@/mocks/streams";

export default function ChatPreview() {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-900">
          <span className="w-5 h-5 flex items-center justify-center text-accent-400">
            <i className="ri-chat-3-line"></i>
          </span>
          实时互动预览
        </h3>
        <span className="rounded-md bg-accent-500/15 px-2 py-0.5 text-[10px] text-accent-400">演示</span>
      </div>

      <div className="relative h-64 overflow-hidden">
        <div className="space-y-2">
          {[...chatMessages, ...chatMessages].map((message, index) => (
            <div key={`${message.id}-${index}`} className="flex items-start gap-2 rounded-md bg-background-50 px-3 py-2">
              <span className="mt-0.5 w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100/10 text-[10px] text-foreground-400">
                {message.user.slice(0, 1)}
              </span>
              <p className="text-xs leading-relaxed text-foreground-600">
                <span className={message.accent ? "text-accent-400" : "text-foreground-400"}>{message.user}：</span>
                {message.text}
              </p>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background-100 to-transparent" />
      </div>

      <p className="mt-3 text-xs leading-relaxed text-foreground-400">
        弹幕与聊天为界面演示，暂未接入真实实时通信，进入直播间可体验完整的互动演示区域。
      </p>
    </div>
  );
}